'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var join = require('../array/join');
var type = require('../value/type');

var reverse = function reverse(array) {
  return [].concat(_toConsumableArray(array)).reverse();
};

module.exports = function (item) {
  if (type(item) === 'string') {
    return join(reverse(item));
  }
  return reverse(item);
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/iterable/reverse.js
// module id = 2187
// module chunks = 37